

<div class="padding-5 br5" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayoutGap="10px">
      <div *ngIf="showGenuineProductIcon" fxLayout="column"
       fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-icon class="primary-icon iconNew">
          verified
        </mat-icon>
        <small>{{genuineProductText}}</small>
      </div>
      <div *ngIf="showTimeIcon" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-icon class="primary-icon iconNew">
          alarm_on
        </mat-icon>
        <small>{{deliveryTime}}</small>
      </div>
      <div *ngIf="deliveryDoorStepIcon" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-icon class="primary-icon iconNew">
          local_shipping
        </mat-icon>
        <small>{{deliveryDoorStepText}}</small>
      </div>
    
      <div *ngIf="displayColdChain" fxLayout="column" 
      fxLayoutAlign="center center" fxLayoutGap="5px">
        <mat-icon class="primary-icon iconNew">
          verified
        </mat-icon>
        <small>{{ColdChain}}</small>
      </div>
    </div>